export const SUPABASE_TABLE_USERS = 'users'
